export default __webpack_public_path__ + "images/bolt-200-5e123dec20ac0a807c4aef4454a5af1f.png";